import type { IssueLinkType } from '@atlassian/jira-issue-shared-types/src/common/types/linked-issue-type.tsx';
import { useIssueLinkTypes } from '@atlassian/jira-settings-service/src/main.tsx';

export const useHasRelatesToIssueLinkType = (): boolean => {
	const issueLinkTypes = useIssueLinkTypes()[0];
	return issueLinkTypes.some((linkType) => linkType.label === 'relates to');
};

export const useRelatesToIssueLinkType = (): IssueLinkType => {
	const issueLinkTypes = useIssueLinkTypes()[0];
	const newRelatesToIssueLinkType = issueLinkTypes.filter(
		(linkType) => linkType.label === 'relates to',
	);
	return newRelatesToIssueLinkType?.[0];
};

/**
 * Helper hook to get all issue link types and the relates to issue link type if it exists
 */
export const useIssueLinkTypesWithRelatesTo = () => {
	const issueLinkTypes = useIssueLinkTypes()[0];
	return {
		issueLinkTypes,
		relatesToIssueLinkType: issueLinkTypes.filter(
			(linkType) => linkType.label === 'relates to',
		)?.[0],
	};
};

export const getRelatesToIssueLinkType = (issueLinkTypes: IssueLinkType[]): IssueLinkType => {
	const newRelatesToIssueLinkType = issueLinkTypes.filter(
		(linkType) => linkType.label === 'relates to',
	);
	return newRelatesToIssueLinkType?.[0];
};

/**
 * Helper hook to get all issue link types and the relates to issue link type if it exists
 */
export const getIssueLinkTypesWithRelatesTo = (issueLinkTypes: IssueLinkType[]) => {
	return {
		issueLinkTypes,
		relatesToIssueLinkType: issueLinkTypes.filter(
			(linkType) => linkType.label === 'relates to',
		)?.[0],
	};
};
